<template lang="pug">
  div
    .layout-view__controls
      v-btn(
        :disabled="!hasPermission('animalfeed_delivery', 'add')"
        medium
        @click="modals.showCreateNew = true")
        v-icon(
          position-left
          font-size="1"
          icon="plus").mr-1
        span {{ 'modals.add_fodder' | translate }}
      
    v-dialog(
      max-width="340"
      v-model="modals.showCreateNew")
      create-fodder-modal(
        @close="modals.showCreateNew = false")

    v-dialog(
      max-width="1000"
      :value="showEditModal"
      @input="closeRecipe")
      edit-recipe-dialog(@update="handleUpdated")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import CreateFodderModal from './modals/CreateFodderModal'
import EditRecipeDialog from './modals/EditRecipeDialog'

export default {
  name: 'ControlsPanel',

  components: {
    CreateFodderModal,
    EditRecipeDialog
  },

  data: () => ({
    modals: {
      showCreateNew: false
    }
  }),

  methods: {
    ...mapActions('recipes', [
      'closeRecipe'
    ]),
    handleUpdated () {
      const { query } = this.$route
      this.$emit('update', query.stock ? query.stock : '-1')
    }
  },

  computed: {
    ...mapGetters('recipes', [
      'currentRecipe'
    ]),

    showEditModal () {
      return !!this.currentRecipe
    }
  }
}
</script>
